export const serverOptions = [
  {
    label: 'Testing Server',
    value: 'https://demo-mode-adapter-api.testing.moneyenergy.xyz',
  },
  { label: 'Local Server', value: 'http://localhost:3300' },
];

export const serverConfigs = {
  'http://localhost:3300': {
    label: 'Local Server',
    tokenUrl: 'http://localhost:3300',
    graphqlUrl: 'http://localhost:3010/graphql',
    simulateUrl: 'http://localhost:3010/sim-bet',
    clientId: '11111111-1111-1111-1111-111111111111',
  },
  'https://demo-mode-adapter-api.testing.moneyenergy.xyz': {
    label: 'Testing Server',
    tokenUrl: 'https://demo-mode-adapter-api.testing.moneyenergy.xyz',
    graphqlUrl: 'https://game-api.testing.moneyenergy.xyz/graphql',
    simulateUrl: 'https://game-api.testing.moneyenergy.xyz/sim-bet',
    clientId: '00000001-0000-0000-0000-000000000000',
  },
};
export const gameMap = {
  'vikings': {
    id: '68ba7a6d-311a-4a4a-8b4c-962032781450',
    SLOT_ID: '68ba7a6d-311a-4a4a-8b4c-962032781450',
    DEFAULT_LINE_SET_ID: '87dde271-bbf9-4537-8587-032e88251e23',
    SLOT_REWARD_DEFAULT: '723090d2-84e9-436a-a0b1-69455a2f7d20',
    SLOT_REEL_DEFAULT_ID: '815f374a-3f12-46b6-8308-cb897a62c043',
    SLOT_REEL_FREE_SPINS_ID: '7727ae30-3baa-4b3e-8875-5e05b0956aae',
    SLOT_REEL_FREE_SPIN_BUY_FEATURE_ID: '1ee94cc7-71a2-4f8f-b23b-085cd1f68468',
    BONUS_GAME_ID: '370a9134-259d-48e5-9d38-10c5cf046498',
  },
  'neon-palace': {
    id: '7acf0ddf-ad1d-4995-810a-ff25dfd2a43c',
    SLOT_ID: '7acf0ddf-ad1d-4995-810a-ff25dfd2a43c',
    DEFAULT_LINE_SET_ID: '0bfc8063-bad8-4ce6-a9e5-f9f64a3f8200',
    SLOT_REEL_DEFAULT_ID: 'd54e996b-907c-4e83-b783-88354b58c798',
  },
  'book-of-books': {
    id: '50d38484-3a3f-4896-b5ab-88c15f37b1ff',
    SLOT_ID: '50d38484-3a3f-4896-b5ab-88c15f37b1ff',
    DEFAULT_LINE_SET_ID: 'aacfc021-ce1d-48ac-985e-6bed546eabbd',
    SLOT_REWARD_DEFAULT: '496c82ec-cd0c-48c8-905f-26678536a6b4',
    SLOT_REEL_DEFAULT_ID: '478ab5ab-84da-45ac-9131-51385dc581bf',
    SLOT_REEL_FREE_SPINS_ID: 'ee68ffff-4da3-4a74-b459-852e771869fd',
  },

  'winter-cocktail': {
    id: 'a4c6f7c5-b9cd-4cdf-83ce-3beaedeaa3e6',
    SLOT_ID: 'a4c6f7c5-b9cd-4cdf-83ce-3beaedeaa3e6',
    DEFAULT_LINE_SET_ID: '2c1e396e-497b-4c9e-bb9f-56b894acfd48',
    SLOT_REEL_DEFAULT_ID: 'b83eaf56-88ed-4056-858d-c11d1c0fa694',
    SLOT_REEL_FREE_SPIN_BUY_FEATURE_ID: '9ed38739-3d39-408f-bb62-4b153f9d2b7c',
  },
  'odyssey': {
    id: 'aff768ca-67e4-4759-8144-ab38baf68518',
    SLOT_ID: 'aff768ca-67e4-4759-8144-ab38baf68518',
    DEFAULT_LINE_SET_ID: 'ec19a10a-2fe4-4cbf-9dd2-a525416e9235',
    SLOT_REWARD_DEFAULT: 'f8055bdb-9110-461f-93dc-a6b25fcb7f55',
    SLOT_REEL_DEFAULT_ID: '22de6860-6921-413d-916c-ad9835e08f44',
    SLOT_REEL_FREE_SPINS_ID: '4d4c05ba-68c1-49d4-8670-2d632ea88251',
    SLOT_REEL_FREE_SPIN_BUY_FEATURE_ID: '9857aae5-22c6-455f-aa24-0d171a445c4e',
  },
  'moonlit-curse': {
    id: '4cfbf240-2423-4bfd-84f7-84856684b743',
    SLOT_ID: '4cfbf240-2423-4bfd-84f7-84856684b743',
    DEFAULT_LINE_SET_ID: 'a02bc235-a580-491a-b906-f15f03d22e3f',
    SLOT_REWARD_DEFAULT: 'c006ea3f-52a7-4384-b0ef-9fd9248abdb7',
    SLOT_REEL_DEFAULT_ID: '244f0394-1538-4521-99cb-a8ff4c8dc81c',
    SLOT_REEL_FREE_SPINS_ID: '2f5ffe71-2e86-4ff8-bef9-c39f2345fa38',
    SLOT_REEL_FREE_SPIN_BUY_FEATURE_ID: '6b2543ee-663f-42ae-adbf-6ea9a953e73e',
  },
};

export const gameOptions = [
  {
    title: 'Vikings',
    value: '68ba7a6d-311a-4a4a-8b4c-962032781450',
    name: 'vikings',
  },
  {
    title: 'Neon-palace',
    value: '7acf0ddf-ad1d-4995-810a-ff25dfd2a43c',
    name: 'neon-palace',
  },
  {
    title: 'Book-of-books',
    value: '50d38484-3a3f-4896-b5ab-88c15f37b1ff',
    name: 'book-of-books',
  },
  {
    title: 'Winter-cocktail',
    value: 'a4c6f7c5-b9cd-4cdf-83ce-3beaedeaa3e6',
    name: 'winter-cocktail',
  },
  {
    title: 'Odyssey',
    value: 'aff768ca-67e4-4759-8144-ab38baf68518',
    name: 'odyssey',
  },
];

export const defaultBetBody = {
  iterationsCount: 100000,
  winsScale: ['100-500', '>500', '<100'],
  betPayload: {
    lineSetId: 'DEFAULT_LINE_SET_ID',
    coinAmount: 3,
    coinValue: 100,
    currency: 'FUN',
    slotId: 'SLOT_ID',
    clientId: '11111111-1111-1111-1111-111111111111',
  },
  config: {
    reelSetId: 'SLOT_REEL_DEFAULT_ID',
    slot: {
      id: 'SLOT_ID',
      name: 'vikings',
      class: 'VIKINGS',
      layout: {
        cols: 5,
        rows: 6,
        screen: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      },
      lines: [],
      settings: {
        bets: {
          minLines: 25,
          maxLines: 25,
        },
        startPosition: [0, 0, 0, 0, 0],
      },
    },
    reelSets: [
      {
        id: 'SLOT_REEL_DEFAULT_ID',
        slot_id: 'SLOT_ID',
        type: 'DEFAULT',
        layout: [
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'F',
            'E',
            'H',
            'C',
            'SC2',
            'A',
            'G',
            'SE2',
            'D',
            'SE2',
            'E',
            'SE2',
            'D',
            'SE2',
            'SE2',
            'SE2',
            'G',
            'SE2',
            'E',
            'SE2',
            'E',
            'SE2',
            'G',
            'SE2',
            'D',
            'SE2',
            'G',
            'D',
            'E',
            'SE2',
            'E',
            'SE2',
            'F',
            'E',
            'H',
            'C',
            'SC1',
            'A',
            'G',
            'SE2',
            'D',
            'SE1',
            'E',
            'SE2',
            'D',
            'SE1',
            'SE2',
            'SE1',
            'G',
            'SE2',
            'E',
            'SE1',
            'E',
            'SE2',
            'G',
            'SE2',
            'D',
            'SE2',
            'G',
            'D',
            'E',
            'SE1',
            'E',
            'SE2',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'E',
            'A',
            'F',
            'G',
            'H',
            'SE2',
            'SE2',
            'C',
            'D',
            'SC2',
            'H',
            'SE2',
            'D',
            'G',
            'SE2',
            'D',
            'F',
            'H',
            'SC2',
            'C',
            'F',
            'SE2',
            'C',
            'SE2',
            'H',
            'SE2',
            'H',
            'SC2',
            'F',
            'SE2',
            'A',
            'G',
            'F',
            'G',
            'SC2',
            'F',
            'SC2',
            'D',
            'SC2',
            'G',
            'SC2',
            'SE2',
            'F',
            'D',
            'H',
            'C',
            'SC2',
            'A',
            'SE2',
            'G',
            'SE2',
            'SC2',
            'D',
            'SC2',
            'C',
            'D',
            'SE2',
            'SC2',
            'SE2',
            'H',
            'E',
            'A',
            'F',
            'G',
            'H',
            'SE2',
            'SE1',
            'C',
            'D',
            'SC1',
            'H',
            'SE1',
            'D',
            'G',
            'SE1',
            'D',
            'F',
            'H',
            'SC1',
            'C',
            'F',
            'SE2',
            'C',
            'SE1',
            'H',
            'SE2',
            'H',
            'SC1',
            'F',
            'SE1',
            'A',
            'G',
            'F',
            'G',
            'SC1',
            'F',
            'SC1',
            'D',
            'SC1',
            'G',
            'SC1',
            'SE1',
            'F',
            'D',
            'H',
            'C',
            'SC1',
            'A',
            'SE1',
            'G',
            'SE2',
            'SC1',
            'D',
            'SC1',
            'C',
            'D',
            'SE1',
            'SC1',
            'SE1',
            'H',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'SE2',
            'A',
            'H',
            'SC2',
            'SE2',
            'E',
            'F',
            'D',
            'C',
            'G',
            'H',
            'SC2',
            'F',
            'SC2',
            'D',
            'SC2',
            'F',
            'G',
            'E',
            'H',
            'G',
            'SC2',
            'C',
            'SE2',
            'A',
            'H',
            'SC1',
            'SE1',
            'E',
            'F',
            'D',
            'C',
            'G',
            'H',
            'SC1',
            'F',
            'SC1',
            'D',
            'SC1',
            'F',
            'G',
            'E',
            'H',
            'G',
            'SC1',
            'C',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'SE2',
            'D',
            'E',
            'H',
            'H',
            'H',
            'A',
            'H',
            'C',
            'G',
            'SC2',
            'SE2',
            'F',
            'SE2',
            'C',
            'H',
            'D',
            'G',
            'H',
            'C',
            'H',
            'C',
            'SE2',
            'A',
            'SE2',
            'G',
            'H',
            'SE2',
            'H',
            'SC2',
            'SE2',
            'A',
            'SE2',
            'G',
            'H',
            'SC2',
            'C',
            'G',
            'H',
            'A',
            'G',
            'H',
            'SE2',
            'D',
            'E',
            'H',
            'H',
            'H',
            'A',
            'H',
            'C',
            'G',
            'SC1',
            'SE1',
            'F',
            'SE1',
            'C',
            'H',
            'D',
            'G',
            'H',
            'C',
            'H',
            'C',
            'SE1',
            'A',
            'SE1',
            'G',
            'H',
            'SE1',
            'H',
            'SC1',
            'SE1',
            'A',
            'SE1',
            'G',
            'H',
            'SC1',
            'C',
            'G',
            'H',
            'A',
            'G',
            'H',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'C',
            'SE2',
            'H',
            'F',
            'E',
            'SE2',
            'SC2',
            'A',
            'D',
            'G',
            'D',
            'E',
            'D',
            'A',
            'D',
            'H',
            'E',
            'D',
            'E',
            'G',
            'E',
            'SE2',
            'SC2',
            'SE2',
            'E',
            'SE2',
            'F',
            'SE2',
            'D',
            'SE2',
            'G',
            'E',
            'SE2',
            'F',
            'G',
            'SE2',
            'SE2',
            'E',
            'SE2',
            'G',
            'A',
            'SC2',
            'E',
            'SE2',
            'SE2',
            'D',
            'H',
            'SE2',
            'A',
            'D',
            'E',
            'D',
            'SE2',
            'C',
            'SE1',
            'H',
            'F',
            'E',
            'SE2',
            'SC1',
            'A',
            'D',
            'G',
            'D',
            'E',
            'D',
            'A',
            'D',
            'H',
            'E',
            'D',
            'E',
            'G',
            'E',
            'SE1',
            'SC1',
            'SE2',
            'E',
            'SE2',
            'F',
            'SE2',
            'D',
            'SE2',
            'G',
            'E',
            'SE2',
            'F',
            'G',
            'SE1',
            'SE2',
            'E',
            'SE2',
            'G',
            'A',
            'SC1',
            'E',
            'SE2',
            'SE1',
            'D',
            'H',
            'SE2',
            'A',
            'D',
            'E',
            'D',
            'SE2',
          ],
        ],
      },
      {
        id: 'SLOT_REEL_FREE_SPINS_ID',
        slot_id: 'SLOT_ID',
        type: 'BONUS',
        layout: [
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'F',
            'E',
            'H',
            'C',
            'SC2',
            'A',
            'G',
            'SE2',
            'D',
            'SE2',
            'E',
            'SE2',
            'D',
            'SE2',
            'SE2',
            'SE2',
            'G',
            'SE2',
            'E',
            'SE2',
            'E',
            'SE2',
            'G',
            'SE2',
            'D',
            'SE2',
            'G',
            'D',
            'E',
            'SE2',
            'E',
            'SE2',
            'F',
            'E',
            'H',
            'C',
            'SC1',
            'A',
            'G',
            'SE2',
            'D',
            'SE1',
            'E',
            'SE2',
            'D',
            'SE1',
            'SE2',
            'SE1',
            'G',
            'SE2',
            'E',
            'SE1',
            'E',
            'SE2',
            'G',
            'SE2',
            'D',
            'SE2',
            'G',
            'D',
            'E',
            'SE1',
            'E',
            'SE2',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'E',
            'A',
            'F',
            'G',
            'H',
            'SE2',
            'SE2',
            'C',
            'D',
            'SC2',
            'H',
            'SE2',
            'D',
            'G',
            'SE2',
            'D',
            'F',
            'H',
            'SC2',
            'C',
            'F',
            'SE2',
            'C',
            'SE2',
            'H',
            'SE2',
            'H',
            'SC2',
            'F',
            'SE2',
            'A',
            'G',
            'F',
            'G',
            'SC2',
            'F',
            'SC2',
            'D',
            'SC2',
            'G',
            'SC2',
            'SE2',
            'F',
            'D',
            'H',
            'C',
            'SC2',
            'A',
            'SE2',
            'G',
            'SE2',
            'SC2',
            'D',
            'SC2',
            'C',
            'D',
            'SE2',
            'SC2',
            'SE2',
            'H',
            'E',
            'A',
            'F',
            'G',
            'H',
            'SE2',
            'SE1',
            'C',
            'D',
            'SC1',
            'H',
            'SE1',
            'D',
            'G',
            'SE1',
            'D',
            'F',
            'H',
            'SC1',
            'C',
            'F',
            'SE2',
            'C',
            'SE1',
            'H',
            'SE2',
            'H',
            'SC1',
            'F',
            'SE1',
            'A',
            'G',
            'F',
            'G',
            'SC1',
            'F',
            'SC1',
            'D',
            'SC1',
            'G',
            'SC1',
            'SE1',
            'F',
            'D',
            'H',
            'C',
            'SC1',
            'A',
            'SE1',
            'G',
            'SE2',
            'SC1',
            'D',
            'SC1',
            'C',
            'D',
            'SE1',
            'SC1',
            'SE1',
            'H',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'SE2',
            'A',
            'H',
            'SC2',
            'SE2',
            'E',
            'F',
            'D',
            'C',
            'G',
            'H',
            'SC2',
            'F',
            'SC2',
            'D',
            'SC2',
            'F',
            'G',
            'E',
            'H',
            'G',
            'SC2',
            'C',
            'SE2',
            'A',
            'H',
            'SC1',
            'SE1',
            'E',
            'F',
            'D',
            'C',
            'G',
            'H',
            'SC1',
            'F',
            'SC1',
            'D',
            'SC1',
            'F',
            'G',
            'E',
            'H',
            'G',
            'SC1',
            'C',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'SE2',
            'D',
            'E',
            'H',
            'H',
            'H',
            'A',
            'H',
            'C',
            'G',
            'SC2',
            'SE2',
            'F',
            'SE2',
            'C',
            'H',
            'D',
            'G',
            'H',
            'C',
            'H',
            'C',
            'SE2',
            'A',
            'SE2',
            'G',
            'H',
            'SE2',
            'H',
            'SC2',
            'SE2',
            'A',
            'SE2',
            'G',
            'H',
            'SC2',
            'C',
            'G',
            'H',
            'A',
            'G',
            'H',
            'SE2',
            'D',
            'E',
            'H',
            'H',
            'H',
            'A',
            'H',
            'C',
            'G',
            'SC1',
            'SE1',
            'F',
            'SE1',
            'C',
            'H',
            'D',
            'G',
            'H',
            'C',
            'H',
            'C',
            'SE1',
            'A',
            'SE1',
            'G',
            'H',
            'SE1',
            'H',
            'SC1',
            'SE1',
            'A',
            'SE1',
            'G',
            'H',
            'SC1',
            'C',
            'G',
            'H',
            'A',
            'G',
            'H',
          ],
          [
            'SE2',
            'SE2',
            'SE2',
            'SE2',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC2',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC2',
            'C',
            'E',
            'C',
            'SC2',
            'C',
            'SC2',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC2',
            'SE1',
            'SE1',
            'SE1',
            'SE1',
            'C',
            'A',
            'H',
            'D',
            'SE2',
            'G',
            'E',
            'SC1',
            'F',
            'C',
            'H',
            'C',
            'D',
            'C',
            'E',
            'H',
            'C',
            'SC1',
            'C',
            'E',
            'C',
            'SC1',
            'C',
            'SC1',
            'C',
            'A',
            'C',
            'E',
            'C',
            'G',
            'D',
            'E',
            'C',
            'E',
            'H',
            'SC1',
            'C',
            'SE2',
            'H',
            'F',
            'E',
            'SE2',
            'SC2',
            'A',
            'D',
            'G',
            'D',
            'E',
            'D',
            'A',
            'D',
            'H',
            'E',
            'D',
            'E',
            'G',
            'E',
            'SE2',
            'SC2',
            'SE2',
            'E',
            'SE2',
            'F',
            'SE2',
            'D',
            'SE2',
            'G',
            'E',
            'SE2',
            'F',
            'G',
            'SE2',
            'SE2',
            'E',
            'SE2',
            'G',
            'A',
            'SC2',
            'E',
            'SE2',
            'SE2',
            'D',
            'H',
            'SE2',
            'A',
            'D',
            'E',
            'D',
            'SE2',
            'C',
            'SE1',
            'H',
            'F',
            'E',
            'SE2',
            'SC1',
            'A',
            'D',
            'G',
            'D',
            'E',
            'D',
            'A',
            'D',
            'H',
            'E',
            'D',
            'E',
            'G',
            'E',
            'SE1',
            'SC1',
            'SE2',
            'E',
            'SE2',
            'F',
            'SE2',
            'D',
            'SE2',
            'G',
            'E',
            'SE2',
            'F',
            'G',
            'SE1',
            'SE2',
            'E',
            'SE2',
            'G',
            'A',
            'SC1',
            'E',
            'SE2',
            'SE1',
            'D',
            'H',
            'SE2',
            'A',
            'D',
            'E',
            'D',
            'SE2',
          ],
        ],
      },
    ],
    lineSets: [
      {
        id: 'DEFAULT_LINE_SET_ID',
        slot_id: 'SLOT_ID',
        lines: [],
        coin_amount_multiplier: 25,
      },
    ],
    lineSetsXReelSets: [
      {
        lineSetId: 'DEFAULT_LINE_SET_ID',
        reelSetId: 'SLOT_REEL_DEFAULT_ID',
        description: 'Default mapping',
      },
      {
        lineSetId: 'DEFAULT_LINE_SET_ID',
        reelSetId: 'SLOT_REEL_FREE_SPINS_ID',
        description: 'Buy feature mapping',
      },
    ],
    slotIcons: [
      {
        icon_id: 'A',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [
              {
                iconId: 'A',
                type: 'COINS',
                multiplier: 50,
              },
            ],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'A', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'B',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'B', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'C',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'C', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'D',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'D', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'E',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'E', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'F',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'F', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'G',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [
              {
                iconId: 'G',
                type: 'COINS',
                multiplier: 25,
              },
            ],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'G', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'H',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 25 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ iconId: 'H', type: 'COINS', multiplier: 100 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'SE1',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x1',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 50 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x2',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x3',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 150 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x4',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 200 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x5',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 250 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x6',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 300 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x7',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 350 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 400 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 450 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 500 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 550 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 600 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 650 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 700 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 750 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 800 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 850 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 900 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 950 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1000 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1050 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1150 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1200 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1250 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1300 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1350 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1400 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1450 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE1', multiplier: 1500 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'SE2',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x1',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x2',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 200 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x3',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 300 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x4',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 400 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x5',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 500 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x6',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 600 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x7',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 700 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 800 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 900 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1000 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1200 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1300 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1400 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1500 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1600 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1700 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1800 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 1900 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2000 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2100 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2200 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2300 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2400 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2500 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2600 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2700 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2800 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 2900 }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS_COINS', iconId: 'SE2', multiplier: 3000 }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'SC1',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x3',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x4',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x5',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x6',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x7',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE1' }],
            payoffType: 'LTR',
          },
        ],
      },
      {
        icon_id: 'SC2',
        slot_id: 'SLOT_ID',
        combos: [
          {
            pattern: 'x3',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x4',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x5',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x6',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x7',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x8',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x9',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x10',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x11',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x12',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x13',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x14',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x15',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x16',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x17',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x18',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x19',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x20',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x21',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x22',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x23',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x24',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x25',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x26',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x27',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x28',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x29',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
          {
            pattern: 'x30',
            type: 'X_OF_KIND',
            rewards: [{ type: 'BONUS', id: 'BONUS_GAME_ID', iconId: 'SE2' }],
            payoffType: 'LTR',
          },
        ],
      },
    ],
    clientSlotSettings: [
      {
        client_id: '11111111-1111-1111-1111-111111111111',
        slot_id: 'SLOT_ID',
        settings: {
          coinAmounts: {
            quick: [1, 2, 3, 5, 12, 20, 40, 100, 300, 1000],
            default: [
              1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 32, 40, 52, 60, 72, 80, 100, 120, 140, 160, 180, 200, 220,
              240, 260, 280, 300, 320, 340, 360, 380, 400, 500, 600, 700, 800, 1000,
            ],
          },
          coinValues: [
            { code: 'FUN', variants: [100] },
            { code: 'EUR', variants: [1] },
          ],
          features: [{ id: 'freeSpins', enabled: true }],
        },
      },
      {
        client_id: '00000000-0000-0000-0000-000000000001',
        slot_id: 'SLOT_ID',
        settings: {
          coinAmounts: {
            quick: [1, 2, 3, 5, 12, 20, 40, 100, 300, 1000],
            default: [
              1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 32, 40, 52, 60, 72, 80, 100, 120, 140, 160, 180, 200, 220,
              240, 260, 280, 300, 320, 340, 360, 380, 400, 500, 600, 700, 800, 1000,
            ],
          },
          coinValues: [
            { code: 'FUN', variants: [100] },
            { code: 'EUR', variants: [1] },
          ],
          features: [{ id: 'freeSpins', enabled: true }],
        },
      },
      {
        client_id: '00000000-0000-0000-0000-000000000010',
        slot_id: 'SLOT_ID',
        settings: {
          coinAmounts: {
            quick: [1, 2, 3, 5, 12, 20, 40, 100, 300, 1000],
            default: [
              1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 32, 40, 52, 60, 72, 80, 100, 120, 140, 160, 180, 200, 220,
              240, 260, 280, 300, 320, 340, 360, 380, 400, 500, 600, 700, 800, 1000,
            ],
          },
          coinValues: [
            { code: 'FUN', variants: [100] },
            { code: 'EUR', variants: [1] },
          ],
          features: [{ id: 'freeSpins', enabled: true }],
        },
      },
      {
        client_id: '00000000-0000-0000-0000-000000000011',
        slot_id: 'SLOT_ID',
        settings: {
          coinAmounts: {
            quick: [1, 2, 3, 5, 12, 20, 40, 100, 300, 1000],
            default: [
              1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 32, 40, 52, 60, 72, 80, 100, 120, 140, 160, 180, 200, 220,
              240, 260, 280, 300, 320, 340, 360, 380, 400, 500, 600, 700, 800, 1000,
            ],
          },
          coinValues: [
            { code: 'FUN', variants: [100] },
            { code: 'EUR', variants: [1] },
          ],
          features: [{ id: 'freeSpins', enabled: true }],
        },
      },
      {
        client_id: 'DEV_GUID',
        slot_id: 'SLOT_ID',
        settings: {
          coinAmounts: {
            quick: [1, 2, 3, 5, 12, 20, 40, 100, 300, 1000],
            default: [
              1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 32, 40, 52, 60, 72, 80, 100, 120, 140, 160, 180, 200, 220,
              240, 260, 280, 300, 320, 340, 360, 380, 400, 500, 600, 700, 800, 1000,
            ],
          },
          coinValues: [
            { code: 'FUN', variants: [100] },
            { code: 'EUR', variants: [1] },
          ],
          features: [{ id: 'freeSpins', enabled: true }],
        },
      },
    ],
    bonuses: [
      {
        id: '370a9134-259d-48e5-9d38-10c5cf046498',
        slot_id: 'SLOT_ID',
        reel_set_id: 'SLOT_REEL_FREE_SPINS_ID',
        line_set_id: 'DEFAULT_LINE_SET_ID',
        type: 'GAME_MODE',
        title: 'Bonus game',
        description: 'Bonus game started when 3 specific scatters appear.',
        purchasable: false,
        rounds: 0,
        data: {
          storeCoinValue: true,
          creditMultiplier: 1,
          debitMultiplier: 0,
          storeCoinAmount: true,
        },
      },
    ],
    slotRewards: [
      {
        id: 'SLOT_REWARD_DEFAULT',
        slotId: 'SLOT_ID',
        priority: 1,
        rules: { SC1: 3 },
        patternType: 'SCATTER',
        rewards: [{ type: 'BONUS', id: '370a9134-259d-48e5-9d38-10c5cf046498' }],
      },
    ],
  },
};
